export default __webpack_public_path__ + "static/media/brain_z.4f5fa303.png";